import * as THREE from "three";

class Image {
  static createImage(name, source) {
    const textureLoader = new THREE.TextureLoader();
    const imgElement = document.createElement("img");
    imgElement.src = source || "";
    imgElement.crossOrigin = "anonymous";
    let material;

    const geometry = new THREE.PlaneGeometry(16, 9);

    const imageTexture = textureLoader.load(source);
    imageTexture.encoding = THREE.sRGBEncoding;

    material = new THREE.MeshBasicMaterial({
      map: imageTexture,
      transparent: true,
      side: THREE.DoubleSide,
    });

    const image = new THREE.Mesh(geometry, material);
    image.position.set(0, 5, 0);
    image.castShadow = true;
    image.receiveShadow = true;
    image.name = name;
    image.userData.canCollide = false;
    image.userData.type = "image";
    image.userData.src = imgElement.src;
    image.userData.isDoubleSide = true;
    image.userData.isDoubleSide = true;

    return image;
  }
}
export default Image;
